module.exports = __webpack_public_path__ + "static/media/bill_chalmers.f94073d4.jpg";